import { useCallback } from 'react';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { setPxParamVariable } from '#src/app/shared/utils/perimeterx';

import { getGuestPerimeterXConfig } from './api';

export function useSetPxGuestUserData(): (email: string) => Promise<void> {
	const utilityContext = useUtilityContext();
	return useCallback(
		async function setPxGuestUserData(email: string) {
			const config = await getGuestPerimeterXConfig(utilityContext, email);
			setPxParamVariable('userId', '');
			setPxParamVariable('accountDate', '');
			setPxParamVariable('emailDomain', config.emailDomain ?? '');
			setPxParamVariable('emailHash', config.emailHash ?? '');
		},
		[utilityContext],
	);
}
